import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { createProvider, Step } from '../../../../../../shared/IFE/step/step/step';
import { UntypedFormBuilder } from '@angular/forms';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AnalyticsService } from '../../../../../../shared/modules/analytics/services/analytics.service';
import { TechnicalDetailsSteps } from '../../models/technical-details-steps';

@Component({
  selector: 'evc-quote-technical-details-intro',
  providers: [createProvider(TechnicalDetailsIntroComponent)],
  templateUrl: './technical-details-intro.component.html',
  styleUrls: ['./technical-details-intro.component.scss'],
})
export class TechnicalDetailsIntroComponent extends Step implements OnInit {
  @Output() continueLater: EventEmitter<any> = new EventEmitter<any>();

  readonly formName = 'evcQuote';
  readonly stepName = 'technical-details-intro';
  href = window.location.href;

  isMobile = this.deviceService.isMobile();
  isTablet = this.deviceService.isTablet();
  isDesktopDevice = this.deviceService.isDesktop();

  constructor(
    fb: UntypedFormBuilder,
    analyticsService: AnalyticsService,
    private deviceService: DeviceDetectorService
  ) {
    super(fb, analyticsService);
    this.control = this.fb.group({});
  }

  navigate() {
    this.formReady.emit();
  }

  continueLaterStep() {
    this.continueLater.emit(TechnicalDetailsSteps.intro);
  }

  protected buildForm() {}
}
